export default "/images/3f79dc05018d6a0135a8a0659d3dc10c.avif";